import "./OperationalFootprint.module.css";
import Header from "@/reusable_sections/Header";
import WeekendRetreat from "./sections/WeekendRetreat";
import BrowseByState from "./sections/BrowseByState";
import BingeWorthyOriginals from "./sections/BingeWorthyOriginals";
import Footer from "@/reusable_sections/Footer";
export default function OperationalFootprintPage() {
  return <div>
      <Header />
      <WeekendRetreat />
      <BrowseByState />
      <BingeWorthyOriginals />
      <Footer />
    </div>;
}